import React from 'react'
import PropTypes from 'prop-types'
import {
  Layout,
  ThemeProvider,
  Grid,
  IconManager,
  coreIconPack,
  Icon,
  Toolbar,
  Link,
} from '@deseretbook/react-ui'
import { Sku, ChannelView } from './views'

/**
 * Renders a container that holds items from the channel
 *
 * @param {Array} items Array of items inside the channel
 * @param {string} name Name of the channel for title use
 * @returns {function}  React Component
 */
const ChannelList = ({ items, name }) => {
  IconManager.register(coreIconPack)

  /**
   * Logic removed from the render method to here. This will handle
   * logic of whether to render the Sku or ChannelView components
   *
   * @param {object} item Indivdual item from prismic for the channels children
   * @returns {function}  React Component
   */
  const handleKindChange = item => {
    if (item.kind === 'sku') {
      return <Sku id={item.id} key={`Sku-${item.id}`} image={item.image} variant={item.variant} />
    }

    return (
      <ChannelView id={item.id} key={`Channel-${item.id}`} image={item.image} name={item.name} />
    )
  }

  return (
    // TODO: dynamic theme
    <ThemeProvider>
      <Layout>
        <Layout.Section>
          <Layout.Content as="header">
            <Link href="/video/discover" aria-label="Back to Discovery" color="video">
              <Icon name="arrowLeft" color="video" />
              Back to Discovery
            </Link>
          </Layout.Content>
          <br />
          <Layout.Content>
            <Toolbar titleContent={name} style={{ color: 'white' }} />
          </Layout.Content>
          <br />
          <Layout.Content>
            <Grid
              gap={2}
              alignItem="center"
              alignContent="center"
              rows="auto"
              columns={Grid.repeat(Grid.autoFill, Grid.minMax(10, Grid.fr(1)))}
            >
              {items.map(item => {
                return <Grid.Item>{handleKindChange(item)}</Grid.Item>
              })}
            </Grid>
          </Layout.Content>
        </Layout.Section>
      </Layout>
    </ThemeProvider>
  )
}

ChannelList.propTypes = {
  name: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      kind: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
}

export default ChannelList
